import { prefixes, prependIntlIds } from "../utils";

export const unprefixedHegMappingMessages = {
  username: "User name",
  login: "login",
  password: "Password",

  change_mapping: "Change mapping",
  submit: "Submit",

  map_user_to_datasource: "Mapping user to {datasourceName}",
} as const;

export default prependIntlIds(
  prefixes.hegMapping,
  unprefixedHegMappingMessages
);
